import { defineNuxtPlugin } from '#app'
import '@lottiefiles/lottie-player'
export default defineNuxtPlugin(() => {
  // Só importando já registra o web component globalmente
})
